(function(){
  if (window.__bcsApple) return; window.__bcsApple = true;

  /* --- Scroll-reveal --- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('bcs-in'); io.unobserve(e.target); } });
  }, { threshold: 0.15 }) : null;

  function scanReveal(){
    document.querySelectorAll('.bcs-reveal:not(.bcs-in)').forEach(function(el){
      if (io) { io.observe(el); } else { el.classList.add('bcs-in'); }
    });
  }

  /* --- Easing helpers (used by step mode) --- */
  function easeInOutCubic(t){ return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function animateScrollTo(el, target, duration, state){
    if (state.raf) cancelAnimationFrame(state.raf);
    var start = el.scrollLeft, change = target - start;
    if (Math.abs(change) < 1) return;
    var t0 = null;
    function step(ts){
      if (state.interrupted) { state.raf = null; return; }
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / duration, 1);
      el.scrollLeft = start + change * easeInOutCubic(p);
      if (p < 1) { state.raf = requestAnimationFrame(step); } else { state.raf = null; }
    }
    state.raf = requestAnimationFrame(step);
  }

  /* --- Shared pause/resume wiring --- */
  function wirePause(track, state, touchResume){
    var resumeTimer = null;
    function pause(){ state.paused = true; state.interrupted = true; if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; } }
    function resumeSoon(delay){ if (resumeTimer) clearTimeout(resumeTimer); resumeTimer = setTimeout(function(){ state.paused = false; state.interrupted = false; state.syncNeeded = true; }, delay); }
    track.addEventListener('mouseenter', pause);
    track.addEventListener('mouseleave', function(){ resumeSoon(600); });
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend', function(){ resumeSoon(touchResume); }, { passive: true });
    track.addEventListener('wheel', function(){ pause(); resumeSoon(2000); }, { passive: true });
    track.addEventListener('focusin', pause);
    track.addEventListener('focusout', function(){ resumeSoon(600); });
  }

  /* --- Constant-velocity marquee (seamless loop over duplicated card set) --- */
  function initMarquee(track){
    var speed = parseFloat(track.getAttribute('data-marquee-speed')) || 40; /* px per second */
    var gap = 20;
    var state = { paused: false, interrupted: false, syncNeeded: false };
    wirePause(track, state, 3000);

    var pos = track.scrollLeft;
    var lastTs = null;

    function loopWidth(){ return (track.scrollWidth + gap) / 2; }

    function frame(ts){
      if (lastTs === null) lastTs = ts;
      var dt = Math.min((ts - lastTs) / 1000, 0.1);
      lastTs = ts;
      if (!state.paused && !document.hidden) {
        if (state.syncNeeded) { pos = track.scrollLeft; state.syncNeeded = false; }
        var lw = loopWidth();
        pos += speed * dt;
        if (lw > 0 && pos >= lw) { pos -= lw; }
        track.scrollLeft = pos;
      } else {
        state.syncNeeded = true;
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* --- Stepped autoplay (kept as an optional mode) --- */
  function initStep(track){
    var interval = (parseFloat(track.getAttribute('data-interval')) || 2) * 1000;
    var slideMs = (parseFloat(track.getAttribute('data-speed')) || 1100);
    var state = { paused: false, interrupted: false, raf: null };
    wirePause(track, state, 4000);
    setInterval(function(){
      if (state.paused || document.hidden || state.raf) return;
      var card = track.querySelector('.bcs-card');
      if (!card) return;
      var step = card.getBoundingClientRect().width + 20;
      var maxScroll = track.scrollWidth - track.clientWidth - 4;
      if (track.scrollLeft >= maxScroll) {
        animateScrollTo(track, 0, Math.max(slideMs * 1.6, 1400), state);
      } else {
        animateScrollTo(track, Math.min(track.scrollLeft + step, maxScroll), slideMs, state);
      }
    }, interval);
  }

  function initShelves(){
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.bcs-shelf__track[data-motion]:not([data-bcs-init])').forEach(function(track){
      track.setAttribute('data-bcs-init', '1');
      if (reduceMotion) return;
      var mode = track.getAttribute('data-motion');
      if (mode === 'marquee') { initMarquee(track); }
      else if (mode === 'step') { initStep(track); }
    });
  }

  function init(){ scanReveal(); initShelves(); }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', init);
})();
